import { Box, Typography } from "@mui/material";
const BannerDevolve = () => {
    return (
        <>
            <Box
                sx={{
                backgroundImage: `url("https://static.meucupom.com/media/LP%20-%20Devolve/Header.png")`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                textAlign: "center",
                height: { xs: '240px', sm: '270px', md: '226px' },
                py: { xs: 10, md: 10, sm: 10 },
                position: "relative",
                color: "#fff",
                }}
            >
                <Box
                component="img"
                src="https://static.meucupom.com/media/LP%20-%20Devolve/Devolve.png"
                alt="MeuCupom Devolve Logo"
                sx={{
                    width: { xs: "60%", md: "300px", sm: "50%" },
                    mb: 6,
                }}
                />
                <Typography
                variant="h4"
                sx={{
                    fontWeight: "bold",
                    color: "#F4CC3B", 
                    fontSize: { xs: "1.2rem", md: "1.5rem" },
                }}
                >
                PARA VOCÊ ECONOMIZAR EM DOBRO!
                </Typography>
            </Box>
        </>
    )
}
export default BannerDevolve;